import React from 'react';

const ReportDeliveryModal = ({
  reportDelivery,
  onReportDeliveryChange,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleChange = (field, value) => {
    onReportDeliveryChange({
      ...reportDelivery,
      [field]: value,
    });
  };

  const handleConfigChange = (field, value) => {
    onReportDeliveryChange({
      ...reportDelivery,
      config: {
        ...reportDelivery.config,
        [field]: value,
      },
    });
  };

  const handleSave = () => {
    // Validar la configuración según el tipo seleccionado
    if (reportDelivery.active) {
      if (!reportDelivery.type) {
        alert('Por favor selecciona un tipo de envío');
        return;
      }

      if (reportDelivery.type === 'webhook' && !reportDelivery.config.url) {
        alert('Por favor ingresa la URL del webhook');
        return;
      }

      if (
        (reportDelivery.type === 'ftp' || reportDelivery.type === 'sftp') &&
        (!reportDelivery.config.host ||
          !reportDelivery.config.username ||
          !reportDelivery.config.password)
      ) {
        alert('Por favor completa todos los campos requeridos para FTP/SFTP');
        return;
      }
    }

    // Mantener toda la información del estado actual
    const updatedReportDelivery = {
      type: reportDelivery.active ? reportDelivery.type : null,
      config: {
        url: reportDelivery.config?.url || '',
        host: reportDelivery.config?.host || '',
        port: reportDelivery.config?.port || '',
        username: reportDelivery.config?.username || '',
        password: reportDelivery.config?.password || '',
        directory: reportDelivery.config?.directory || '/',
      },
      active: reportDelivery.active || false,
    };

    // Actualizar el estado con la configuración completa
    onReportDeliveryChange(updatedReportDelivery);

    // Si todo está bien, cerrar el modal
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Configuración de envío de reportes
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500 focus:outline-none"
              >
                <span className="sr-only">Cerrar</span>
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={reportDelivery.active}
                  onChange={e => handleChange('active', e.target.checked)}
                  className="mr-2"
                />
                <label>Activar envío de reportes</label>
              </div>

              {reportDelivery.active && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Tipo de envío
                    </label>
                    <select
                      value={reportDelivery.type || ''}
                      onChange={e => handleChange('type', e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                    >
                      <option value="">Seleccionar tipo</option>
                      <option value="webhook">Webhook</option>
                      <option value="ftp">FTP</option>
                      <option value="sftp">SFTP</option>
                    </select>
                  </div>

                  {reportDelivery.type === 'webhook' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        URL del Webhook
                      </label>
                      <input
                        type="text"
                        value={reportDelivery.config.url}
                        onChange={e =>
                          handleConfigChange('url', e.target.value)
                        }
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        placeholder="https://ejemplo.com/webhook"
                      />
                    </div>
                  )}

                  {(reportDelivery.type === 'ftp' ||
                    reportDelivery.type === 'sftp') && (
                    <>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Host
                        </label>
                        <input
                          type="text"
                          value={reportDelivery.config.host}
                          onChange={e =>
                            handleConfigChange('host', e.target.value)
                          }
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                          placeholder="ftp.ejemplo.com"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Puerto
                        </label>
                        <input
                          type="text"
                          value={reportDelivery.config.port}
                          onChange={e =>
                            handleConfigChange('port', e.target.value)
                          }
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                          placeholder="21 o 22"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Usuario
                        </label>
                        <input
                          type="text"
                          value={reportDelivery.config.username}
                          onChange={e =>
                            handleConfigChange('username', e.target.value)
                          }
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                          placeholder="usuario"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Contraseña
                        </label>
                        <input
                          type="password"
                          value={reportDelivery.config.password}
                          onChange={e =>
                            handleConfigChange('password', e.target.value)
                          }
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                          placeholder="********"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Directorio
                        </label>
                        <input
                          type="text"
                          value={reportDelivery.config.directory}
                          onChange={e =>
                            handleConfigChange('directory', e.target.value)
                          }
                          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                          placeholder="/reportes"
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={handleSave}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Guardar
            </button>
            <button
              type="button"
              onClick={onClose}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportDeliveryModal;
